import axiosWrapper from '@/utils/request'

const fetchContainerByInvoice = (
  containerId,
  invoiceId,
  invoiceAuthToken,
  token
) => {
  return axiosWrapper({
    url: `platform/containers/${containerId}/invoices/${invoiceId}/${invoiceAuthToken}`,
    headers: {
      Authorization: 'Token ' + token
    }
  })
}
const fetchShippingLines = () => {
  return axiosWrapper({
    url: '/platform/shipping_lines'
  })
}

export default {
  fetchContainerByInvoice,
  fetchShippingLines
}
